import { render, staticRenderFns } from "./case-identifiers.html?vue&type=template&id=73fcdd1a&scoped=true&"
import script from "./case-identifiers.js?vue&type=script&lang=js&"
export * from "./case-identifiers.js?vue&type=script&lang=js&"
import style0 from "./case-identifiers.scss?vue&type=style&index=0&id=73fcdd1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fcdd1a",
  null
  
)

export default component.exports